const { REACT_APP_HOST_API, REACT_APP_NODE_ENV, REACT_APP_HOST_RELOAD} = process.env

window.appConfig = {
  tokenStorageKey: 'accessToken',
  refreshStorageKey: 'refreshToken',
  timeouts: {},
  appPrefix: '/app',
  settingPrefix: '/setting',
  appEnv: REACT_APP_NODE_ENV,
  apiUrl: REACT_APP_HOST_API,
  reloadUrl: REACT_APP_HOST_RELOAD,
  dateFormat: 'DD/MM/YYYY',
  dateFormatPattern: '/[0-9]{2}/[0-9]{2}/[0-9]{4}/',
  openStreetMap: {
    url: 'https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png',
    attribution:
      '&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors',
  },
  fileErrors: {
    'file-too-large': 'Il file supera le dimensioni consentite',
  },
  actions: {
    auth: {
      login: {
        path: '/auth/login',
      },
      loginfail: {
        path: '/auth/loginfail',
      },
      appConfig: {
        path: '/user-manager/users/app-config',
      },
    },
    agenda: {
      get: {
        path: '/agenda-data',
      },
      search: {
        path: '/agenda-search',
      },
    },
    sidebar: {
      path: '/user-manager/users/sidebar',
    },
    print: {
      status: {
        path: '/print/status',
      },
      cancel: {
        path: '/print/cancel',
      },
    },
  },
  daysOfWeek: [
    {
      value: 0,
      label: 'Lunedì',
      shortLabel: 'lun',
    },
    {
      value: 1,
      label: 'Martedì',
      shortLabel: 'mar',
    },
    {
      value: 2,
      label: 'Mercoledì',
      shortLabel: 'mer',
    },
    {
      value: 3,
      label: 'Giovedì',
      shortLabel: 'gio',
    },
    {
      value: 4,
      label: 'Venerdì',
      shortLabel: 'ven',
    },
    {
      value: 5,
      label: 'Sabato',
      shortLabel: 'sab',
    },
    {
      value: 6,
      label: 'Domenica',
      shortLabel: 'dom',
    },
  ],
  messages: {
    errorRequestComponent: {
      message: 'Non è stato possibile caricare completamente la pagina.',
      action: 'Riprova',
    },
  },
}
